import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { removeFromLocalStorage } from "@/utils/helpers";

import { useStore } from 'vuex';
import { ref, nextTick, onMounted } from 'vue';
export default {
  __name: 'PortfolioSelector',
  setup: function setup(__props) {
    var store = useStore();
    var portfolio = ref(null);
    function handleActivePortfolioChange(_x) {
      return _handleActivePortfolioChange.apply(this, arguments);
    }
    function _handleActivePortfolioChange() {
      _handleActivePortfolioChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(store.state.portfolio.activePortfolioId === id)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              store.commit("portfolio/setActivePortfolio", id);
              removeFromLocalStorage("bq:trading:base-asset");
              removeFromLocalStorage("bq:trading:quote-asset");
              removeFromLocalStorage("bq:trading:selected-account");
              removeFromLocalStorage("bq:trading:exchange");
              _context.next = 9;
              return nextTick();
            case 9:
              window.location.reload();
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _handleActivePortfolioChange.apply(this, arguments);
    }
    onMounted(function () {
      portfolio.value = store.state.portfolio.activePortfolio;
    });
    return function (_ctx, _cache) {
      var _component_PBIcon = _resolveComponent("PBIcon");
      var _component_PBDropdown = _resolveComponent("PBDropdown");
      return _unref(portfolio) ? (_openBlock(), _createBlock(_component_PBDropdown, {
        key: 0,
        modelValue: _unref(portfolio),
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = function ($event) {
          return _isRef(portfolio) ? portfolio.value = $event : null;
        }), _cache[1] || (_cache[1] = function (value) {
          return handleActivePortfolioChange(value.id);
        })],
        "text-key": "name",
        "value-key": "id",
        options: _unref(store).state.portfolio.portfolios,
        search: "",
        width: "240px",
        auto: "",
        height: 400,
        scrollable: ""
      }, {
        icon: _withCtx(function () {
          return [_createVNode(_component_PBIcon, {
            name: "portfolio",
            w: 21,
            h: 21
          })];
        }),
        option: _withCtx(function (_ref) {
          var option = _ref.option;
          return [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(option.name) + " ", 1), _createElementVNode("div", {
            "class": _normalizeClass(["mt-sm flex leading-none items-center text-sm", {
              'text-success': option.isActive,
              'text-warning': !option.isActive
            }])
          }, [_createElementVNode("span", {
            "class": _normalizeClass(["min-w-[6px] h-[6px] mr-[4px] rounded-full", {
              'bg-success': option.isActive,
              'bg-warning': !option.isActive
            }])
          }, null, 2), _createTextVNode(" " + _toDisplayString(option.isActive ? "Active" : "Inactive"), 1)], 2)])];
        }),
        _: 1
      }, 8, ["modelValue", "options"])) : _createCommentVNode("", true);
    };
  }
};